export default __webpack_public_path__ + "assets/de97bc661841e0128d1869a32b250129.svg";